import React from 'react'
import { Button as ButtonUnstyled } from '@mui/base'

import './button.scss'

export const Button = ({ children, ...props }) => {
  const { className, variant } = props

  return (
    <ButtonUnstyled className={className + ' button ' + variant} {...props}>
      {children}
    </ButtonUnstyled>
  )
}
